import React from 'react';
import SidebarOptions from './SidebarOptions';
import '../css/Sidebar.css'
function Sidebar(){
return (
    <div className='sidebar'>
      <SidebarOptions/>
    </div>
)
}

export default Sidebar;